import { Container } from "components/layout/Container";
import { Breadcrumbs } from "components/shared/Breadcrumbs";
import { Title } from "components/typography/Title";
import { Button } from "components/UI/Buttons/Button";
import { useArticleSinglePageContext } from "@/helpers/contexts/ArticleSinglePageContext";

import { TabButton } from "@/components/UI/Buttons/TabButton";

import { InputSearchCollapsible } from "@/components/form/InputSearchCollapsible";
import { useCallback, useState } from "react";
import { useRedirect } from "@/helpers/useRedirect";
import cn from "classnames";
import { DropdownLinksSelect } from "@/components/UI/Dropdowns/DropdownLinksSelect";
import { ArticleInfo } from "@/components/pages/blog/article/ArticleInfo";
import Image from "next/image";
import { TArticleInfo } from "@/components/pages/blog/article/TArticleInfo";

type ArticleHeaderProps = {
  showShareBtn?: boolean;
  showCategoriesSearch?: boolean;
  isTranslation?: boolean;
};
export const ArticleHeader = ({
  showShareBtn,
  showCategoriesSearch = true,
  isTranslation,
}: ArticleHeaderProps) => {
  const data = useArticleSinglePageContext();
  const [deskCategoriesVisible, setDeskCategoriesVisible] = useState(true);

  const redirect = useRedirect();

  const handleSearchInputToggle = useCallback((value: boolean) => setDeskCategoriesVisible(!value), []);

  const handleSearchSubmit = useCallback((value: string) => redirect(`/blog?search=${value}`), [redirect]);

  if (!data) return null;
  const { article, breadcrumbsList } = data;
  const { heading, thumbnail: givenThumb, aiThumbnail, categories } = article;

  // @ts-ignore
  const thumbnailUrl = aiThumbnail || givenThumb?.url?.url || givenThumb?.url || "";

  const category = categories?.data?.[0]?.attributes;

  return (
    <Container className="sc-article-header">
      {breadcrumbsList && (
        <Breadcrumbs color="black" list={breadcrumbsList} className="sc-article-header__breadcrumbs" />
      )}

      {showCategoriesSearch && (
        <>
          <div className="sc-article-header__top">
            <div
              className={cn("sc-article-header__top-categories", {
                "sc-article-header__top-categories--hidden": !deskCategoriesVisible,
              })}
            >
              <div>
                <TabButton text="All" href="/blog" small />
              </div>
              {data.categoriesWithSubcategories.map(({ heading, slug }) => (
                <TabButton
                  text={heading}
                  href={`/${slug}`}
                  small
                  key={slug}
                  className="sc-article-header__tab-button"
                />
                // <DropdownLinks
                //   key={slug}
                //   placeholder={heading}
                //   items={[]}
                //   // items={subcategories.map((subcat, id) => ({
                //   //   id,
                //   //   name: <Link href={`/${slug}/${subcat.slug}`}>{subcat.heading}</Link>,
                //   // }))}
                // />
              ))}
            </div>
            <div className="sc-article-header__search">
              <InputSearchCollapsible onSubmit={handleSearchSubmit} onToggle={handleSearchInputToggle} />
            </div>
          </div>

          <div className="sc-article-header__top-mob">
            <DropdownLinksSelect
              placeholder="Select Category"
              items={[
                {
                  id: -1,
                  url: "/blog",
                  name: "All",
                },
                ...data.categoriesWithSubcategories.map(({ heading, slug }, id) => ({
                  id,
                  url: `/${slug}`,
                  name: heading,
                })),
              ]}
            />

            <InputSearchCollapsible
              onSubmit={handleSearchSubmit}
              onToggle={handleSearchInputToggle}
              collapsible={false}
            />
          </div>
        </>
      )}

      <div className="sc-article-header__wrapper">
        <div className="sc-article-header__main">
          <div className="sc-article-header__categories">
            {!!category && (
              <Button
                key={category.slug}
                href={`/${category.slug}`}
                type="primary"
                outline
                size="xs"
                className="sc-article-header__category"
              >
                {category.heading}
              </Button>
            )}
          </div>
          <Title level={1} className="sc-article-header__heading" html={heading} />
        </div>
        <div className="sc-article-header__img-wrap">
          {thumbnailUrl && (
            <Image
              src={thumbnailUrl}
              alt=""
              title=""
              width={440}
              height={270}
              quality={100}
              className="sc-article-header__img"
            />
          )}
        </div>
        {isTranslation ? (
          <TArticleInfo showShareBtn={showShareBtn} />
        ) : (
          <ArticleInfo showShareBtn={showShareBtn} />
        )}
      </div>
    </Container>
  );
};
